
import { defineComponent, reactive, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { useHead } from '@vueuse/head'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const SeasonRepository = RepositoryFactory.get('season')

import BaseBreadcrumb, { Breadcrumb } from '@/components/BaseBreadcrumb.vue'


import { Season } from '@/types/season'
import { Game } from '@/types/game'
import { Group } from '@/types/group'
import { EntryTeam } from '@/types/entryTeam'

export default defineComponent({
  name: 'SeasonDetailHome',
  inheritAttrs: false,
  components: {
    BaseBreadcrumb,
  },
  setup() {
    const route = useRoute()
    const store = useStore()

    onMounted(() => {
      getSeason()
    })

    const season: {
      data?: Season
      todays?: Game[]
      groups?: Group[]
      entries?: EntryTeam[]

      isLoading: boolean
    } = reactive({
      data: undefined,
      todays: undefined,
      groups: undefined,
      entries: undefined,

      isLoading: false
    })

    const getSeason = async () => {
      try {
        season.isLoading = true

        const { season_id } = route.params

        const res = await SeasonRepository.getSeason(season_id)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          season.data = data.season
          season.todays = data.todays
          season.groups = data.groups
          season.entries = data.entries
        }
      } catch (error) {
        //
      } finally {
        season.isLoading = false
      }
    }

    const updateSeason = async (name: string) => {
      try {
        const { season_id } = route.params

        const dataObj = {
          season_id: season_id,
          name: name
        }

        const res = await SeasonRepository.updateSeason(dataObj)

        if (res.status === 200) {
          store.dispatch('addFlashMessage', {
            type: 'success',
            message: 'シーズン名を変更しました'
          })
        }
      } catch (error) {
        //
      }
    }

    useHead({
      title: computed(() => `${season.data?.topic_name} ${season.data?.name} - 大会詳細`),
    })

    const breadcrumbs = computed(() => {
      return [
        {
          type: 'link',
          link: {
            name: '大会一覧',
            path: '/'
          }
        },
        {
          type: 'input',
          size: 'large',
          input: {
            name: season.data?.topic_name,
            inputName: season.data?.name
          },
          setting: {
            path: '/event/' + route.params.topic_id
          }
        }
      ] as Breadcrumb[]
    })

    return {
      season,
      getSeason,
      updateSeason,

      breadcrumbs
    }
  }
})
